<template>
    <v-expand-transition>
        <div class="inb-entry-buttons">
            <div>
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            depressed
                            small
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            class="inb-entry-button"
                            @click="onConfirm"
                        >
                            <v-icon small color="white">fas fa-check</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("crm.entry.commit") }}</span>
                </v-tooltip>
            </div>

            <div>
                <v-tooltip left >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            depressed
                            small
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            class="inb-entry-button"
                            @click="onGotoIncident"
                        >
                            <v-icon small color="white">fas fa-arrow-left</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t ("crm.entry.goto") }}</span>
                </v-tooltip>
            </div>
        </div>

    </v-expand-transition>
</template>

<script>

import Inc from "@/modules/inc/service/Inc.js";
import Crm from "@/modules/crm/service/Crm.ts";

export default {
    name: "CrmReminderEntryMenu",

    props: {
        reminder: {
            required: true
        },
        value: {
            required: true
        }
    },

    methods: {
        onGotoIncident() {
            this.$emit('input', false);
            Inc.goto(this, this.reminder.incident.id);
        },

        onConfirm() {
            Crm.confirm(this.reminder.id, () => {
                this.$bus.$emit(Inc.events.journal);
            })
        },
    }
}
</script>

<style scoped>

.inb-message-buttons {
    position: absolute;
    width: 20px;
    display: block;
    right: 25px;
    top: 5px;
}

.inb-entry-buttons {
    width: 100%;
    margin-bottom: 10px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
}

.inb-entry-button {
    min-width: 25px!important;
    padding-left: 10px!important;
    margin: 0!important;
}


</style>